import { Component, inject, Input } from '@angular/core';
import { ListPageColumnComponent } from '../list-page/list-page.utils';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'ui-priority-status',
  imports: [ MatChipsModule, CommonModule ],
  templateUrl: './priority-status.html',
  styleUrl: './priority-status.scss'
})
export class PriorityStatus extends ListPageColumnComponent {
  private translocoService = inject(TranslocoService);

  @Input() priority: string;

  ngOnInit(): void {
    if(this.itemData && this.infoColumn) {
      this.priority = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  getCssClass() {
    switch (this.priority) {
      case 'Low': // 0:
        return 'priority-low';
      case 'Medium': // 1:
        return 'priority-medium';
      case 'High': // 2:
        return 'priority-high';
      default:
        return 'priority-unknown';
    }
  }

  getLabel() {
    switch (this.priority) {
      case 'Low': // 0:
        return this.translocoService.translate('designSystem.priority.low');
      case 'Medium': // 1:
        return this.translocoService.translate('designSystem.priority.medium');
      case 'High': // 2:
        return this.translocoService.translate('designSystem.priority.high');
      default:
        return 'Priorità sconosciuta';
    }
  }

  // TODO: Implementare metodo di normalizzazione dell'input
  // private normalizePriority(value: number | string | null | undefined): number {
  //   //Se ho un numero, lo mantengo
  //   if (value === 0 || value === 1 || value === 2) {
  //     return value;
  //   }

  //   //Se ho una stringa, la normalizzo
  //   if (typeof value === 'string') {
  //     const v = value.toLowerCase().trim();

  //     if (v === 'low') return 0;
  //     if (v === 'medium') return 1;
  //     if (v === 'high') return 2;
  //   }

  //   //Fallback dato errato
  //   return -1;
  // }
}
